import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import useGetAppSelected from "src/hooks/useGetAppSelected";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";
import InfoTerms from "./InfoTerms";

// ----------------------------------------------------------------------

export const InfoTitle = () => {
	const { values } = useContext(Context);
	const app = useGetAppSelected();
	const { translate } = useLocales();

	return (
		<Stack>
			<Typography variant='subtitle1' color={values.primaryTextColor}>
				{translate("customization.connect_account_with")}
			</Typography>
			<Typography variant='h4' sx={{ mb: 1 }} color={values.primaryTextColor}>
				{app?.displayName}
			</Typography>
			<InfoTerms />
		</Stack>
	);
};

export default InfoTitle;
